import { render, staticRenderFns } from "./ClientSettingsModal.vue?vue&type=template&id=63cc3ce6&"
import script from "./ClientSettingsModal.vue?vue&type=script&lang=js&"
export * from "./ClientSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientSettingsModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports